var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessIcon = function SvgSuccessIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#008050"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 40,
    cy: 40,
    r: 36,
    fill: "#008050"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3787 31.813L50.0816 28.5065C50.0268 28.4515 49.9616 28.4079 49.8899 28.3781C49.8181 28.3483 49.7412 28.333 49.6636 28.333C49.5859 28.333 49.509 28.3483 49.4373 28.3781C49.3655 28.4079 49.3004 28.4515 49.2455 28.5065L35.3202 42.4413C35.2653 42.4963 35.2001 42.5399 35.1284 42.5697C35.0567 42.5994 34.9798 42.6148 34.9021 42.6148C34.8244 42.6148 34.7475 42.5994 34.6758 42.5697C34.6041 42.5399 34.5389 42.4963 34.4841 42.4413L31.1869 39.1347C31.1321 39.0797 31.0669 39.0361 30.9952 39.0063C30.9235 38.9766 30.8466 38.9613 30.7689 38.9613C30.6912 38.9613 30.6143 38.9766 30.5426 39.0063C30.4709 39.0361 30.4057 39.0797 30.3509 39.1347L27.0537 42.4413C26.943 42.552 26.8809 42.7022 26.8809 42.8587C26.8809 43.0153 26.943 43.1655 27.0537 43.2762L34.4841 50.7077C34.5389 50.7627 34.6041 50.8063 34.6758 50.8361C34.7475 50.8659 34.8244 50.8812 34.9021 50.8812C34.9798 50.8812 35.0567 50.8659 35.1284 50.8361C35.2001 50.8063 35.2653 50.7627 35.3202 50.7077L53.3787 32.6397C53.4869 32.5293 53.5475 32.3809 53.5475 32.2264C53.5475 32.0718 53.4869 31.9234 53.3787 31.813Z",
    fill: "#008050"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "success-icon.9b3b83c32e5e08f83529ae61ad3fc40a.svg";